import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import { Navbar, Footer, Sidebar, ThemeSettings } from "./components";
import { 
  Page404,
  GantiPassword,
  Homepage,
  TeamPage,
  AboutUs,
  OurMissionValues,
  ConsultingPage,
  ViewStories,
  ProgramPage,
  ViewProgram,
  PortfolioPage,
  StoriesPage,
  EtalasePage,
  DonatePage,
  OurBoardPage,
  CekPesanan,
  Dashboard,
  LoginPage,
  ListTeam,
  ListProgram,
  ListProduk,
  ListStories,
  ListComment,
  AddTeam,
  AddProgram,
  AddProduk,
  AddStories,
  EditTeam,
  EditProgram,
  EditProduk,
  EditStories,
} from "./Pages";

import { useStateContext } from "./contexts/ContextProvider";
import { LanguageProvider } from "./contexts/LanguageContext";

import "./App.css";

const AppContent = () => {
  const { activeMenu, currentMode, themeSettings } = useStateContext();
  const location = useLocation();
  const isHomepage = location.pathname === "/";
  const isTeamPage = location.pathname === "/team";
  const isAboutUs = location.pathname === "/about";
  const isOurMissionValues = location.pathname === "/our-mission-values";
  const isConsultingPage = location.pathname === "/consulting";
  const isViewStories = location.pathname.startsWith("/view-stories/");
  const isProgramPage = location.pathname === "/program";
  const isViewProgram = location.pathname.startsWith("/view-program/");
  const isPortfolioPage = location.pathname === "/portfolio";
  const isStoriesPage = location.pathname === "/stories";
  const isEtalasePage = location.pathname === "/etalase";
  const isDonatePage = location.pathname === "/donate";
  const isOurBoardPage = location.pathname === "/our-board";
  const isCekPesanan = location.pathname === "/cek-pesanan";
  const isLoginPage = location.pathname === "/login";
  const isDashboard = location.pathname === "/dashboard";

  // Toggle class body-no-scroll
  useEffect(() => {
    if (activeMenu) {
      document.body.classList.add("body-no-scroll");
    } else {
      document.body.classList.remove("body-no-scroll");
    }

    return () => {
      document.body.classList.remove("body-no-scroll");
    };
  }, [activeMenu]);

  return (
    <div className={currentMode === "Dark" ? "dark" : ""}>
      <div className="flex relative dark:bg-main-dark-bg">
        
        {/* Theme Settings Modal */}
        {themeSettings && <ThemeSettings />}

        {/* Sidebar */}
        { !isLoginPage && !isHomepage && !isTeamPage && !isAboutUs && !isOurMissionValues && !isConsultingPage && !isViewStories && !isProgramPage && !isViewProgram && !isPortfolioPage && !isStoriesPage && !isEtalasePage && !isCekPesanan && !isDonatePage && !isOurBoardPage &&  activeMenu ? (
          <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white">
            <Sidebar />
          </div>
        ) : !isLoginPage && !isHomepage && !isTeamPage && !isAboutUs && !isOurMissionValues && !isConsultingPage && !isViewStories && !isProgramPage && !isViewProgram && !isPortfolioPage && !isStoriesPage && !isEtalasePage && !isCekPesanan && !isDonatePage && !isOurBoardPage ? (
          <div className="w-0 dark:bg-secondary-dark-bg">
            <Sidebar />
          </div>
        ) : null}

        {/* Main Content */}
        <div
          className={`main-content dark:bg-main-dark-bg bg-main-bg min-h-screen w-full ${
            activeMenu && !isLoginPage && !isHomepage && !isTeamPage && !isAboutUs && !isOurMissionValues && !isConsultingPage && !isViewStories && !isProgramPage && !isViewProgram && !isPortfolioPage && !isStoriesPage && !isEtalasePage && !isCekPesanan && !isDonatePage && !isOurBoardPage ? "sidebar-visible" : "full-width"
          }`}
        >
          { !isLoginPage && !isHomepage && !isTeamPage && !isAboutUs && !isOurMissionValues && !isConsultingPage && !isViewStories && !isProgramPage && !isViewProgram && !isPortfolioPage && !isStoriesPage && !isEtalasePage && !isCekPesanan && !isDonatePage && !isOurBoardPage && (
            <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full">
              <Navbar />
            </div>
          )}

          <div>

            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/our-mission-values" element={<OurMissionValues />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/consulting" element={<ConsultingPage />} />
              <Route path="/view-stories/:slug" element={<ViewStories />} />
              <Route path="/program" element={<ProgramPage />} />
              <Route path="/view-program/:slug" element={<ViewProgram />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/stories" element={<StoriesPage />} />
              <Route path="/etalase" element={<EtalasePage />} />
              <Route path="/cek-pesanan" element={<CekPesanan />} />
              <Route path="/our-board" element={<OurBoardPage />} />  
              <Route path="/login" element={<LoginPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/ganti-password" element={<GantiPassword />} />
              <Route path="/list-team" element={<ListTeam />} />
              <Route path="/list-program" element={<ListProgram />} />
              <Route path="/list-produk" element={<ListProduk />} />
              <Route path="/list-stories" element={<ListStories />} />
              <Route path="/list-komentar" element={<ListComment />} />
              <Route path="/add-team" element={<AddTeam />} />
              <Route path="/add-program" element={<AddProgram />} />
              <Route path="/add-produk" element={<AddProduk />} />
              <Route path="/add-stories" element={<AddStories />} />
              <Route path="/team/edit/:id" element={<EditTeam />} />
              <Route path="/program/edit/:id" element={<EditProgram />} />
              <Route path="/produk/edit/:id" element={<EditProduk />} />
              <Route path="/stories/edit/:id" element={<EditStories />} />
              <Route path="/donate" element={<DonatePage />} />
              <Route path="/our-board" element={<OurBoardPage />} />
              {/* Admin Routes */}

              <Route path="/page-not-found" element={<Page404 />} />
              <Route path="*" element={<Page404 />} />
            </Routes>
          </div>

          { !isLoginPage && !isDashboard && !isHomepage && !isTeamPage && !isAboutUs && !isOurMissionValues && !isConsultingPage && !isViewStories && !isProgramPage && !isViewProgram && !isPortfolioPage && !isStoriesPage && !isEtalasePage && !isCekPesanan && !isDonatePage && !isOurBoardPage && <Footer /> }
        </div>
      </div>
    </div>
  );
};

const App = () => (
  <LanguageProvider>
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  </LanguageProvider>
);

export default App;